import Api from "@/services/api";
import { NewsRenderCredentials } from "@/services/dashboard/types";

export async function getNewsRenderCredentials(date: Date, language: string): Promise<NewsRenderCredentials> {
    return new Promise((resolve, reject) => {
        Api.post("/dashboard", { date: date, language: language }).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
